import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'

Vue.use(Router)

const userPage = ()=>import(/* webpackChunkName: "third" */ './views/User.vue')
const thirdPage = ()=>import(/* webpackChunkName: "third" */ './views/Third.vue')
const passwordPage = ()=>import(/* webpackChunkName: "password" */ './views/Password.vue')
const realNamePage = ()=>import(/* webpackChunkName: "real_name" */ './views/RealName.vue')
const phonePage = ()=>import(/* webpackChunkName: "phone" */ './views/Phone.vue')
const emailPage = ()=>import(/* webpackChunkName: "email" */ './views/Email.vue')
const questionPage = ()=>import(/* webpackChunkName: "question" */ './views/Question.vue')
const complaintPage = ()=>import(/* webpackChunkName: "question" */ './views/Complaint.vue')
const forgotPage = ()=>import(/* webpackChunkName: "forgot" */ './views/Forgot.vue')
const chargePage = ()=>import(/* webpackChunkName: "charge" */ './views/Charge.vue')
const recahrgeHistoryPage = ()=>import(/* webpackChunkName: "charge_history" */ './views/ChargeHistory.vue')
const thirdBindPage = ()=>import(/* webpackChunkName: "third" */ './views/ThirdBind.vue')

const routes = [
  {
    path: '/user',
    name: 'user',
    component: userPage
  },
  {
    path: '/third',
    name: 'third',
    component: thirdPage
  },
  {
    path: '/password',
    name: 'password',
    component: passwordPage
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: forgotPage
  },
  {
    path: '/authentication',
    name: 'realName',
    component: realNamePage
  },
  {
    path: '/phone',
    name: 'phone',
    component: phonePage
  },
  {
    path: '/email',
    name: 'email',
    component: emailPage
  },
  {
    path: '/securityQuestion',
    name: 'question',
    component: questionPage
  },
  {
    path: '/AccountComplaint',
    name: 'complaint',
    component: complaintPage
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: chargePage
  },
  {
    path: '/recahrgeHistory',
    name: 'recahrgeHistory',
    component: recahrgeHistoryPage
  }
]
export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/user',
      name: 'home',
      component: Home,
      children:routes
    },
    {
      path: '/thirdBind',
      name: 'thirdBind',
      component: thirdBindPage
    },
  ]
})
